<template>
<Fragment>
    <LoadingApp
        :isLoading.sync="isLoading" 
        :is_full_page="true"
    /> 
    <cart-summary class="cart-summary">
        <h3 style="text-align: center;">Pedido</h3>

        <h4>
            <p 
                class="collapsed" 
                role="button"
                style="text-align: center;"
            >
                Preencha os dados para contato
            </p>
        </h4>
            
        <form 
            @submit.prevent="submit"
            method="post"
            ref="form"
            style="margin-bottom: unset !important"
        >   
            <div class="form-group form-group-sm">
                <label>Email</label>
                <input 
                    type="email" 
                    v-model="form.email"  
                    class="form-control form-control-sm"
                />
                <div v-if="submited && !$v.form.email.required" class="required">* Email obrigatório</div>
            </div>
            <div class="form-group form-group-sm">
                <label>CPF/CNPJ</label>
                <input 
                    type="text" 
                    v-model="form.user_cpfcnpj"  
                    v-mask="maskRegister" 
                    @keypress="typePerson(form.user_cpfcnpj)" 
                    class="form-control form-control-sm"
                />
                <div v-if="submited && !$v.form.user_cpfcnpj.required" class="required">* CPF/CNPJ obrigatório</div>
            </div>
            <div class="form-group form-group-sm">
                <label>Nome/Razão Social</label>
                <input 
                    type="text" 
                    v-model="form.user_company_name" 
                    class="form-control form-control-sm"
                />
                <div v-if="submited && !$v.form.user_company_name.required" class="required">* Nome/Razão Social obrigatório</div>
            </div>
            <div class="form-group form-group-sm">
                <label for="postal_code">CEP</label>
                <input 
                    type="text" 
                    class="form-control form-control-sm" 
                    v-model="form.postal_code" 
                    id="postal_code" 
                    @change="consultaCep(form.postal_code)"
                    v-mask="'#####-###'"
                    name="postal_code"
                />
                <span>
                    <a @click.prevent="$root.showModalApp('modal_cep')" class="link-postal-code-search">
                        <small>Não sei meu cep</small>
                    </a>
                </span>
                <div v-if="submited && !$v.form.postal_code.required" class="required">* CEP obrigatório</div>
            </div>
            <div class="form-group form-group-sm">
                <label>Cidade</label>
                <input 
                    type="text" 
                    v-model="form.city" 
                    class="form-control form-control-sm"
                    readonly
                />
                <div v-if="submited && !$v.form.city.required" class="required">* Cidade obrigatório</div>
            </div>
            <div class="form-group form-group-sm">
                <label>UF</label>
                <input 
                    type="text" 
                    v-model="form.uf" 
                    class="form-control form-control-sm"
                    readonly
                />
                <div v-if="submited && !$v.form.uf.required" class="required">* UF obrigatório</div>
            </div>
            <div class="form-group form-group-sm">
                <label>Endereço</label>
                <input 
                    type="text" 
                    v-model="form.address" 
                    class="form-control form-control-sm"
                />
                <div v-if="submited && !$v.form.address.required" class="required">* Endereço obrigatório</div>
            </div>
            <div class="form-group form-group-sm">
                <label>Número</label>
                <input 
                    type="text" 
                    v-model="form.number" 
                    class="form-control form-control-sm"
                />
            </div>
            <div class="form-group form-group-sm">
                <label>Complemento</label>
                <input 
                    type="text" 
                    v-model="form.complement" 
                    class="form-control form-control-sm"
                />
            </div>
            
            <div class="form-group form-group-sm">
                <label>Bairro</label>
                <input 
                    type="text" 
                    v-model="form.district" 
                    class="form-control form-control-sm"
                />
            </div>
            <div class="form-group form-group-sm">
                <label>Telefone</label>
                <input 
                    type="text" 
                    v-model="form.phone" 
                    class="form-control form-control-sm"
                    v-mask="'(##) #####-####'"
                />
                <div v-if="submited && !$v.form.phone.required" class="required">* Telefone obrigatório</div>
            </div>
            <div class="form-group form-group-sm">
                <label>WhatsApp</label>
                <input 
                    type="text" 
                    v-model="form.whatsapp" 
                    v-mask="'(##) #####-####'" 
                    class="form-control form-control-sm"
                />
            </div>

            <div class="checkout-methods">
                <c-button
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    fontSize="1.4rem"
                    height="3.8rem"
                    margin="20px 0px 0px 0px"
                    justifyContent="center"
                    type="submit"
                    class="btn-block"
                >
                    Solicitar Orçamento
                </c-button>
            </div>
        </form>
    </cart-summary>
    <SearchPostalCode
        @searchedCep="searchedCep"
    />
</Fragment>
</template>

<script>
import LoadingApp from '../../components/LoadingApp'
import { VueMaskDirective } from 'v-mask'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { Fragment } from 'vue-fragment'
import {CButton} from '../../components/Styles/Button/styled'
import ConsultaCep from '../../api/consultaCep'
import { CCartSummary } from '../../components/Styles/Template/styled'
import SearchPostalCode from '../../components/SearchPostalCode.vue'

export default {
    name: 'FormularioPedido',
    directives: {
        'mask': VueMaskDirective
    },
    components: {
        LoadingApp,
        Fragment,
        SearchPostalCode,
        'c-button': CButton,
        'cart-summary': CCartSummary
    },
    data() {
        return {
            isLoading: false,
            form: {
                user_cpfcnpj: null,
                user_company_name: null,
                phone: null,
                whatsapp: null,
                email: null,
                city: null,
                uf: null,
                address: null,
                number: null,
                district: null,
                postal_code: null,
                complement: null,
                _token: jQuery('meta[name="csrf-token"]').attr('content')
            },
            maskRegister: "###.###.###-##",
            submited: false
        }
    },
    validations: {
        form: {
            user_cpfcnpj: {required},
            user_company_name: {required},
            phone:{required},
            email: {required},
            city: {required},
            uf: {required},
            address: {required},
            postal_code: {required}
        }
    },
    methods: {
        ...mapActions("cart", [
            "ActionSendClientOrcamento"
        ]),
        searchedCep(cep){
           this.form.postal_code = cep
           this.consultaCep(cep)
        },
        submitForm()
        {
            this.$refs.form.submit()
        },
        typePerson(val) 
        {   
            if(!val) {
                return
            }
            if(val.replace(/\D/g, '').length >= 11) {
                this.maskRegister = "##.###.###/####-##"
                return
            }
            this.maskRegister = "###.###.###-##" 
        },

        async submit()
        {   
            this.isLoading = true
            this.submited = true
            if(this.$v.$invalid) {
                this.isLoading = false
                this.$v.form.$touch()
                return
            }
                
            await this.send()
        },

        async send()
        {   
            await this.ActionSendClientOrcamento(this.form)
            .then((resp) => {
                this.isLoading = false
                alert('Pedido enviado com sucesso!')
                window.location.href = this.$baseUrl
            })
            .catch((error) => {
                this.isLoading = false
                if(error.msg) {
                    alert(error.msg)
                    return
                }
                alert(error)
            })
        },

        async consultaCep(cep_consulta) {
            if(!cep_consulta) {
                return
            }
            try {
                let {
                    erro=null, 
                    bairro=null, 
                    cep=null, 
                    complemento=null,
                    gia=null, 
                    ibge=null, 
                    localidade=null, 
                    logradouro=null, 
                    uf=null, 
                    unidade=null

                } = await ConsultaCep.get(cep_consulta)
                if(erro) {
                    alert('CEP inválido!')
                    return
                }
                this.form.city = localidade.toUpperCase()
                this.form.uf = uf.toUpperCase()
                this.form.district = bairro.toUpperCase()
                this.form.address = logradouro.toUpperCase()
                this.form.complement = complemento
                this.form.ibge = ibge
            } catch(error) {
                alert(error)
            }
        },
    }
    
}
</script>

<style scoped>
.link-postal-code-search {
    cursor: pointer;
}
.link-postal-code-search:hover small {
    text-decoration: underline;
}
</style>